import { memo } from 'react';
import { type NodeProps } from 'reactflow';
import { Database, FileText, Table, HardDriveDownload } from 'lucide-react';
import { BaseNodeUI } from './BaseNodeUI';

const DestinationNode = ({ data, selected }: NodeProps) => {
    const destType = data.destinationType || 'Table';

    const Icon =
        destType === 'File' ? FileText :
        destType === 'Dataset' ? Table :
        destType === 'DataModel' ? HardDriveDownload :
        Database;

    const bgClass =
        destType === 'File' ? 'bg-green-500' :
        destType === 'Dataset' ? 'bg-blue-500' :
        destType === 'DataModel' ? 'bg-violet-500' :
        'bg-indigo-500';

    return (
        <BaseNodeUI
            title={data.label || 'Destination'}
            icon={Icon}
            colorClass=""
            bgClass={bgClass}
            selected={selected}
            isTarget={true}
            isSource={false}   // Sinks have no output handle
            executionStatus={data?.executionStatus}
        />
    );
};

export default memo(DestinationNode);